var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderPreviousIcconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50391 19.2822C8.69304 19.2997 8.88127 19.2415 9.02734 19.1201C9.17343 18.9987 9.26576 18.8239 9.2832 18.6348C9.3005 18.4461 9.24199 18.2582 9.12109 18.1123L2.73438 10.4541L2.35938 10.0039L2.72656 9.54785L8.89942 1.88867L8.90625 1.87988C8.99362 1.77502 9.04935 1.64714 9.06641 1.51172C9.08337 1.3765 9.06142 1.2393 9.00293 1.11621C8.94431 0.992954 8.85117 0.888628 8.73535 0.816407C8.6197 0.744377 8.48587 0.706467 8.34961 0.708009L8.34961 0.708985L8.33887 0.708009C8.23224 0.707646 8.12663 0.731689 8.03028 0.777344C7.95788 0.811685 7.89178 0.858097 7.83496 0.914063L7.78125 0.972657L0.881837 9.54395L0.876954 9.5498C0.77201 9.67753 0.714923 9.83762 0.714845 10.0029C0.714845 10.1668 0.770877 10.3259 0.874024 10.4531L8.01855 19.0264L8.01855 19.0273C8.13997 19.1734 8.31476 19.2648 8.50391 19.2822Z",
    fill: "#006AB3",
    stroke: "#CD2A3F",
    strokeWidth: 1.42887
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPreviousIcconNew);
export default __webpack_public_path__ + "static/media/sliderPreviousIcconNew.f007e79938a813f00690b86804e57a46.svg";
export { ForwardRef as ReactComponent };